export default {
    headPortrait: '/basic/users/getImage', //获取头像
    getName: '' //获取用户名
};
